import { render } from "./DestroyPropertyDialog.vue?vue&type=template&id=1fb4aa9e&scoped=true"
import script from "./DestroyPropertyDialog.vue?vue&type=script&lang=js"
export * from "./DestroyPropertyDialog.vue?vue&type=script&lang=js"

import "./DestroyPropertyDialog.vue?vue&type=style&index=0&id=1fb4aa9e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1fb4aa9e"]])

export default __exports__